<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="ModalBaslik"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
  >
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">

        <el-col :span="24">
          <el-form-item label="Ekip Adı" prop="adi">
            <el-input type="text" v-model="Form.adi" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>


      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
    </div>
  </el-dialog>

</template>

<script>
import BinaListe from "../../Bina/BinaListe";

export default {
  props: ['Bilgi', 'Durum', 'Tur'],
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      Form: {},
      FormHata: {
        adi: [{required: true, message: "Ekip Adı Giriniz", trigger: 'blur'}],
      },
    }
  },
  methods: {
    Kapat() {
      this.$emit('Durum')
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          this.$store.dispatch(this.Tur, {...this.Form, path: 'ekip'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                  if (this.Tur == 'Post') this.$router.push("/ekip/");
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    }
  },
  created() {
    if (this.Bilgi) {
      this.Form = this.Bilgi
      this.ModalBaslik = this.Bilgi.Unvan
    } else {
      this.Form = {}
      this.ModalBaslik = 'Ekip Ekle'
    }
    this.$store.dispatch("Get", {path: 'ekip'})
        .then(response => {
          this.Bolgeler = response.Data
        })
  },
  watch: {
    Bilgi: function () {
      this.Form = this.Bilgi
      this.ModalBaslik = 'Ekip Düzenle';

    },
    Tur: function () {
      if (this.Tur == 'Post') this.ModalBaslik = 'Ekip Ekle'; else this.ModalBaslik = 'Ekip Düzenle';
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ekip/Comp/Modal.vue